import React from 'react';
import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers/index';
import VerifiedIcon from 'images/verified.svg';
import BuildingIcon from 'images/icons/building.svg';
import { PropertyManagerFooter } from './PropertyManagerFooter';
import * as styles from './propertyManagerModule.styles';

const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const parseOfficeHours = (contactTimes: string): Array<string> => {
  const dayPattern = new RegExp(`(${DAYS.join('|')})`, 'g');
  const hasDayLabels = dayPattern.test(contactTimes);

  if (!hasDayLabels) return [contactTimes];

  const lines: Array<string> = [];
  const splitPattern = new RegExp(`(?=${DAYS.join('|')})`, 'g');
  const parts = contactTimes.split(splitPattern).filter(Boolean);

  for (const part of parts) {
    lines.push(part.trim());
  }

  return lines;
};

export const PropertyManagerModule = () => {
  const listing = useSelector((state: RootReduxState) => state.currentListingDetails?.currentListing);

  if (!listing) return null;

  const { trusted, details, displayName, address } = listing;
  const contactTimes = details?.contactTimes;
  const officeHoursLines = contactTimes ? parseOfficeHours(contactTimes) : [];
  const managerName = displayName && displayName !== address?.street ? displayName : '';

  if (!managerName && !trusted && officeHoursLines.length === 0) {
    return null;
  }

  return (
    <div>
      {managerName && <div className={styles.managerName}>{managerName}</div>}
      {trusted && (
        <div className={styles.verifiedBadge}>
          <img src={VerifiedIcon} alt="" aria-hidden="true" className={styles.verifiedIcon} />
          <span>Verified listing</span>
        </div>
      )}
      {officeHoursLines.length > 0 && (
        <div className={styles.officeHours}>
          <div className={styles.officeHoursLabel}>
            <img src={BuildingIcon} alt="" aria-hidden="true" className={styles.managerIcon} />
            <span>Office hours</span>
          </div>
          {officeHoursLines.map((line) => (
            <div key={line} className={styles.officeHoursLine}>
              {line}
            </div>
          ))}
        </div>
      )}
      <PropertyManagerFooter />
    </div>
  );
};
